import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  isAutomationSupported: boolean
  onClose: () => void
  onConfirm: () => void
  showModal: boolean
}

export default function PortfolioConfirmTradesModal({
  isAutomationSupported,
  onClose,
  onConfirm,
  showModal,
}: Props) {
  return (
    <Modal isCentered isOpen={showModal} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <PDSBox>
            {isAutomationSupported ? (
              <PDSHeader variant="h3">Place Suggestions Immediately?</PDSHeader>
            ) : (
              <PDSHeader variant="h3">Confirm Trade Approval?</PDSHeader>
            )}
          </PDSBox>
        </ModalHeader>
        <ModalBody>
          {isAutomationSupported ? (
            <>
              <PDSBox>
                <PDSText size="md">
                  You have scheduled these suggested trades to be placed on the
                  portfolio’s existing monthly trade cadence.
                </PDSText>
              </PDSBox>
              <PDSBox>
                <PDSText size="md">
                  If you would like Pave Pro to place these trades during the
                  next trading day instead, please press confirm below.
                </PDSText>
              </PDSBox>
            </>
          ) : (
            <>
              <PDSBox>
                <PDSText size="md">
                  Are you sure you want to approve your suggested trades? This
                  action cannot be undone. Once approved, suggested trades will
                  be placed the following trading day. This action cannot be
                  undone.
                </PDSText>
              </PDSBox>
              <PDSBox marginTop={SIZE.s8}>
                <PDSText size="md">
                  This action may trigger a wash sale as your last set of trades
                  may have been placed within the last 30 days. Wash sales
                  relate to realizing losses and trading the same security
                  within a 30 day window. Wash sales will be listed on a
                  brokerage statement and may be disclosed to the IRS. Please
                  contact a tax adviser for guidance.
                </PDSText>
              </PDSBox>
            </>
          )}
        </ModalBody>

        <ModalFooter marginBottom={SIZE.s8}>
          <PDSFlexBox gap={SIZE.s8} width="100%">
            <PDSButton
              onClick={onConfirm}
              size="md-f"
              text="Confirm"
              variant="primary"
            />

            <PDSButton
              onClick={onClose}
              size="md-f"
              text="Cancel"
              variant="secondary"
            />
          </PDSFlexBox>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
